<template>
    <div class="">

        <VMap style="max-height: 500px; aspect-ratio: 1/1;" :center="mapCenter" :zoom="mapZoom">
            <VMapOsmTileLayer attribution="Open Street Map"/>
            <VMapZoomControl/>
            <VMapAttributionControl/>
            <VMapPinMarker v-for="(mapPin, index) in mapPins" :key="index" @click="centerMapOnPin(mapPin)" :latlng="[mapPin.lat, mapPin.lng]">
                <VMapPinIcon>
                    <svg
                        data-name="Group 138"
                        width="24"
                        height="36"
                        viewBox="0 0 66.665001 99.896097"
                        version="1.1"
                        id="svg13"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:svg="http://www.w3.org/2000/svg">
                        <defs
                            id="defs5">
                            <clipPath
                                id="jvp825l7ea">
                                <path
                                    data-name="Rectangle 79"
                                    style="fill:#CE5232"
                                    d="M 0,0 H 66.665 V 99.9 H 0 Z"
                                    id="path2"/>
                            </clipPath>
                        </defs>
                        <g
                            data-name="Group 137"
                            clip-path="url(#jvp825l7ea)"
                            id="g11"
                            transform="translate(0,-0.00390625)">
                            <path
                                id="path7"
                                style="fill:#CE5232"
                                d="M 33.332031,0.00390625 C 6.856163,0.00390625 -9.0509736,29.383574 5.421875,51.554688 L 33.332031,99.900391 61.244141,51.554688 C 75.716989,29.383574 59.8079,0.00390625 33.332031,0.00390625 Z M 32.921875,21.5 c 6.592094,-0.166723 13.013059,4.902503 13.013672,12.625 -0.0077,6.95672 -5.642894,12.595851 -12.599609,12.607422 C 22.103217,46.737768 16.474498,33.15882 24.414062,25.214844 26.895177,22.732352 29.925469,21.575783 32.921875,21.5 Z"/>
                        </g>
                    </svg>
                </VMapPinIcon>
            </VMapPinMarker>
        </VMap>
    </div>
</template>


<script>
    import {defineComponent} from 'vue'
    import {VMap, VMapOsmTileLayer, VMapZoomControl, VMapAttributionControl, VMapPinMarker, VMapPinIcon, VMapDefaultIcon} from 'vue-map-ui';

    import 'leaflet/dist/leaflet.css';
    import 'vue-map-ui/dist/normalize.css';
    import 'vue-map-ui/dist/style.css';
    import 'vue-map-ui/dist/theme-all.css';

    export default {
        name: "MultiPinMap",
        data: {
            mapCenterInitial: [0,0],
            mapZoomInitial: 12,
            mapCenter: [0,0],
            mapZoom: 12,
            mapPins: [],
            elementID: 0,
        },
        props: {
            center: {
                type: Array,
                default: () => [0, 0]
            },
            zoom: {
                type: Number,
                default: 8
            },
            element_id: {
                type: [String, Number],
                default: ''
            },
            pins: {
                type: [Array, String],
                default: () => []
            },
        },
        methods: {
            centerMapOnPin: function (pin) {
                this.mapCenter = [0,0];
                this.mapZoom = 0;
                
                this.$nextTick(() => {
                    this.mapCenter = [pin.lat, pin.lng];
                    this.mapZoom = 18;
                });
            },
            resetMap: function () {
                this.mapCenter = this.mapCenterInitial;
                this.mapZoom = this.mapZoomInitial;
            }
        },
        mounted() {
            this.mapPins = typeof this.pins === 'string' ? JSON.parse(this.pins) : this.pins;

            // center on first pin
            this.mapCenter = this.mapPins.length > 0 ? [this.mapPins[0].lat, this.mapPins[0].lng] : this.mapCenterInitial;
            this.mapCenterInitial = this.mapCenter;

            this.mapZoom = typeof this.zoom === 'string' ? parseInt(JSON.parse(this.zoom)) : this.zoom;
            this.mapZoomInitial = this.mapZoom;

            this.elementID = typeof this.element_id === 'string' ? parseInt(JSON.parse(this.element_id)) : this.element_id;
        },
        components: {
            VMap,
            VMapOsmTileLayer,
            VMapZoomControl,
            VMapAttributionControl,
            VMapPinMarker,
            VMapDefaultIcon,
            VMapPinIcon
        }
    }
</script>

<style scoped>
    .reset-button {
        text-align: center;
    }

    .reset-button span {
        display: inline-block;
        padding: 3px 10px;
        margin-bottom: -1rem;
        cursor: pointer;
    }

    .map-pin {
        margin-top: 1rem;
        background: rgba(255,255,255,0.7);
        width: 10rem;
        padding: 1rem;
        border-radius: 1rem;
        margin-top: -40px;
        margin-left: 40px;
    }
</style>
